import React, { useCallback } from 'react';
import { Text, Modal, ModalBody, ModalCloseButton, ModalFooterButtons, ModalHeader } from '@televet/kibble-ui';
import { CareMembershipEvents } from 'shared/providers/TrackingProvider/EventNames';
import { useTracking } from 'shared/providers/TrackingProvider';

interface IConfirmCloseModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleClose: (confirm: boolean) => void;
  currentStep: number;
}

const ConfirmCloseModal = ({ isOpen, onClose, handleClose, currentStep }: IConfirmCloseModalProps): JSX.Element => {
  const { trackEvent } = useTracking();

  const handleConfirmClose = useCallback(() => {
    trackEvent(CareMembershipEvents.WizardClose, { currentStep });
    onClose();
    handleClose(false);
  }, [currentStep, handleClose, onClose, trackEvent]);

  return (
    <>
      <Modal size="xs" isOpen={isOpen} onClose={onClose} isCentered={true}>
        <ModalHeader>Are you sure?</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontWeight="bold">
            Exiting calculate benefits will delete all changes you have made. Would you still like to proceed to exit?
          </Text>
        </ModalBody>
        <ModalFooterButtons isDestructive onSubmit={handleConfirmClose} submitText="Yes, exit" />
      </Modal>
    </>
  );
};

export default ConfirmCloseModal;
